module.exports = "<navbar></navbar>\n<header>\n  <hero></hero>\n</header>\n<main>\n  <div>\n    <h1>Found in {{ vm.name }}.html</h1>\n  </div>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/home.html
// module id = 256
// module chunks = 0